import clsx from "clsx";
import classes from "./Paragraph.module.css";

interface ParagraphInterface {
    item: any;
    notClickable: boolean;
    onParagraphClick: any;
    url: string;
}

const Paragraph = ({ item, notClickable, onParagraphClick, url }: ParagraphInterface) => {
    return (
        <div
            onClick={() => onParagraphClick(item.url)}
            style={{
                backgroundColor: item.url === url && !notClickable ? "white" : undefined,
            }}
            className={clsx(classes.description, [!notClickable && item.url && classes.clickable])}
            dangerouslySetInnerHTML={{
                __html: item.content,
            }}
            key={item.url}
        ></div>
    );
};

export default Paragraph;